import { Component, DestroyRef, inject, input, OnChanges, OnInit, signal } from '@angular/core';
import { WheelDynamicText } from '../../models/wheel-of-fortune.model';
import { TranslateService } from '@ngx-translate/core';
import { DomSanitizer } from '@angular/platform-browser';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { take, tap } from 'rxjs';
import { NgClass } from '@angular/common';
import { CountryCityNotificationService } from 'src/app/shared/utils/services/country-city-notification.service';

@Component({
  selector: 'app-wheel-dynamic-text',
  standalone: true,
  imports: [NgClass],
  templateUrl: './wheel-dynamic-text.component.html',
  styleUrl: './wheel-dynamic-text.component.scss'
})
export class WheelDynamicTextComponent implements OnInit, OnChanges{
  public data = input.required<WheelDynamicText>();

  public translatedText = signal('');

  private readonly domSanitizer = inject(DomSanitizer);

  private readonly translate = inject(TranslateService);

  private readonly destroyRef = inject(DestroyRef);

  private readonly languageService = inject(CountryCityNotificationService);

  ngOnInit() {
    this.languageService.languageChanged$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next:()=>this.translateInputText()
      })
  }

  ngOnChanges() {
    this.translateInputText();
  }

  private translateInputText(): void {
    const { html, text, translateKeyValuePairs } = this.data();
      this.translate.get(html||text||'', translateKeyValuePairs)
        .pipe(
          take(1),
          tap((res) => this.translatedText.set(res)),
          takeUntilDestroyed(this.destroyRef)
        )
        .subscribe();
    }
}
